import "./MultiPlayTable.scss";
import {useTranslation} from "react-i18next";

const MultiPlayTable = () => {
  const {t} = useTranslation();

  return (
    <div className="results-delux">
      <div className="multiplay-table">
        <div className="multiplay-table-title">
          <h3>{t('multiplay table')}</h3>
        </div>
        <div className="multiplay-table-box">
          <p>{t('suit number')} = 144</p>
          <p>{t('suit sector')} = 24</p>
          <p>{t('suit dozen')} = 14</p>
          <p>{t('suit color')} = 8</p>
          <p>{t('suit eo')} = 8</p>
          <p>{t('suit uo')} = 8</p>
        </div>

        <div className="multiplay-table-box">
          <p>{t('joker number')} = 1296</p>
          <p>{t('joker sector')} = 216</p>
          <p>{t('joker dozen')} = 108</p>
          <p>{t('joker color')} = 72</p>
          <p>{t('joker eo')} = 72</p>
          <p>{t('joker uo')} = 72</p>
        </div>
      </div>
    </div>
  );
};

export default MultiPlayTable;
